import React, { useState, useEffect } from "react";
import { Spin } from "antd";
import { Field, FormikProvider, useFormik } from "formik";
import * as Yup from "yup";
import {
  Button,
  Col,
  Form,
  Modal,
  OverlayTrigger,
  Row,
  Tooltip,
} from "react-bootstrap";
import { Link } from "react-router-dom";
import { SVGICON } from "../../../constant/theme";

import CustomSizePerPage from "../../../CustomControls/CustomSizePerPage";
import CustomPaginationButtons from "../../../CustomControls/CustomPaginationButtons";
import { post } from "../../../helpers/api_helper";
import CustomInput from "../../../CustomControls/CustomInput";
import CustomSelect from "../../../CustomControls/CustomSelect";
import CustomFlatpickr from "../../../CustomControls/CustomFlatpickr";

import {
  POST_DDLGetTestMasterByDepartmentID,
  POST_GetAllCustomerRepresentativeDropDown,
  POST_GetDepartmentDropDownList,
  POST_GetSampleDepartmentReceivedMarkingDetail,
  POST_GetTestingList,
  POST_SampleDepartmentReceivedMarkingInsert,
  POST_TestingsDelete,
} from "../../../helpers/url_helper";
import moment from "moment";
import CustomMultiSelect from "../../../CustomControls/CustomMultiSelect";
import { useFilter } from "../../../../context/FilterContext";
import TestingApproval from "./TestingApproval";
import {
  delete_Record,
  errorMessage,
  successMessage,
} from "../CommonFunctions";
import TestingNDTApproval from "./TestingNDTApproval";
import CustomTextArea from "../../../CustomControls/CustomTextArea";

const Testing = () => {
  const { filter, updateFilter } = useFilter();
  const [showFilter, setShowFilter] = useState(false);

  const [isLoading, setIsLoading] = useState(false);

  const [currentPage, setCurrentPage] = useState(
    filter && filter?.page == "testing" ? filter?.CurrentPage : 1,
  );
  const [currentSizePerPage, setCurrentSizePerPage] = useState(
    filter && filter?.page == "testing" ? filter?.PageSize : 10,
  );
  const [recordCount, setRecordCount] = useState(0);
  const [sortBy, setSortBy] = useState(
    filter && filter?.page == "testing" ? filter?.sortBy : "",
  );
  const [orderBy, setOrderBy] = useState(
    filter && filter?.page == "testing" ? filter?.orderBy : "asc",
  );

  const [isReset, setIsReset] = useState(false);

  //const [testingList, setTestingList] = useState([]);
  const [departmentOptions, setDepartmentOptions] = useState([]);
  const [testOptions, setTestOptions] = useState([]);

  const AuthUser = JSON.parse(localStorage.getItem("userDetails"));
  const formsList = AuthUser?.Permissions?.FormList;

  const [showTestingApprovalModal, setShowTestingApprovalModal] =
    useState(false);

  const [inwardMaterialID, setInwardMaterialID] = useState("");

  const [showTestingNDTApprovalModal, setShowTestingNDTApprovalModal] =
    useState(false);
  const [setshowIsNDT, setIsNDT] = useState(false);
  const [customerRepresentativeOptions, setCustomerRepresentativeOptions] =
    useState([]);

  // const [testStatusOptions, setTestStatusOptions] = useState([]);
  const [testStatusOptions, setTestStatusOptions] = useState([
    { label: "Pending", value: 1 },
    { label: "Draft Save", value: 2 },
    { label: "Unapproved", value: 3 },
    { label: "Approved", value: 4 },
    { label: "Revise & Rectify", value: 5 },
  ]);

  useEffect(() => {
    getDepartmentDDL();
    getTestDDL();
    getStatusDDL();
    getCustomerRepresentativeDDL();
  }, []);

  useEffect(() => {
    getData(currentPage, currentSizePerPage);
  }, [sortBy, orderBy]);

  useEffect(() => {
    if (isReset == true) {
      getData(currentPage, currentSizePerPage);
      setIsReset(false);
    }
  }, [isReset]);

  const handleClickSorting = (columnName) => {
    setCurrentPage(1);
    if (sortBy == columnName) {
      if (orderBy == "asc") {
        setOrderBy("desc");
      } else {
        setSortBy("");
        setOrderBy("asc");
      }
    } else {
      setSortBy(columnName);
      setOrderBy("asc");
    }
  };

  const validationSchema = Yup.object().shape({});

  const formik = useFormik({
    validationSchema,
    onSubmit: (values, formikHelpers) =>
      handleValidSubmit(values, formikHelpers),
    initialValues: {
      testingList: [],
    },
    validateOnBlur: false,
  });

  const {
    handleValidSubmit,
    values: { testingList },
  } = formik;

  const tPIRequiredOptions = [
    { label: "All", value: -1 },
    { label: "Yes", value: 1 },
    { label: "No", value: 0 },
  ];

  const currentDate = new Date();

  const validationSchemaFilter = Yup.object().shape({});

  const formikFilter = useFormik({
    validationSchemaFilter,
    onSubmit: (values, formikHelpers) =>
      handleValidSubmitFilter(values, formikHelpers),
    initialValues: {
      TCNo: filter && filter?.page == "testing" ? filter?.TCNo : "",
      InwardNo: filter && filter?.page == "testing" ? filter?.InwardNo : "",
      FromDate:
        filter && filter?.page == "testing"
          ? filter?.FromDate
          : new Date(currentDate.setMonth(currentDate.getMonth() - 1)),
      ToDate: filter && filter?.page == "testing" ? filter?.ToDate : new Date(),
      DepartmentID:
        filter && filter?.page == "testing" ? filter?.DepartmentID : "",

      TestingStatus:
        filter && filter?.page == "testing"
          ? filter?.TestingStatus
          : (testStatusOptions?.filter(
              (x) => x.value == 1 || x.value == 2 || x.value == 3,
            ) ?? ""),

      TestID: filter && filter?.page == "testing" ? filter?.TestID : "",
      TPIRequired:
        filter && filter?.page == "testing" ? filter?.TPIRequired : -1,
      CustomerRepresentativeIDEncrypt:
        filter && filter?.page == "testing"
          ? filter?.CustomerRepresentativeIDEncrypt
          : "",
      TestingPending: 0,
      TestingDraftSave: 0,
      TestingUnapproved: 0,
      TestingApproved: 0,
      TestingRejectRectify: 0,
      TotalTesting: 0,
    },
    validateOnBlur: false,
  });

  const {
    handleValidSubmitFilter,
    values: {
      TCNo,
      FromDate,
      ToDate,
      InwardNo,
      DepartmentID,
      TestingStatus,
      TestID,
      TPIRequired,
      TestingPending,
      TestingDraftSave,
      TestingUnapproved,
      TestingApproved,
      TestingRejectRectify,
      TotalTesting,
      CustomerRepresentativeIDEncrypt,
    },
  } = formikFilter;

  useEffect(() => {
    if (ToDate && ToDate < FromDate) {
      formikFilter.setFieldValue("ToDate", FromDate);
    }
  }, [FromDate]);

  const getData = async (page = 1, sizePerPage = 10) => {
    setIsLoading(true);
    //alert(FromDate);

    updateFilter({
      page: "testing",
      CurrentPage: page,
      PageSize: sizePerPage,
      sortBy: sortBy,
      orderBy: orderBy,
      TCNo: TCNo,
      InwardNo: InwardNo,
      FromDate: FromDate ? FromDate : "",
      ToDate: ToDate ? ToDate : "",
      DepartmentID: DepartmentID,
      TestingStatus: TestingStatus,
      TestID: TestID,
      TPIRequired: TPIRequired,
      CustomerRepresentativeIDEncrypt: CustomerRepresentativeIDEncrypt,
    });

    let payload = {
      CurrentPage: page,
      PageSize: sizePerPage,
      Search: "",
      Sorting: sortBy ? sortBy + " " + orderBy : "",
      BranchIDEncrypted: AuthUser?.BranchIDEncrypt,
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
      TCNo: TCNo,
      InwardNo: InwardNo,
      TestingStatus: Array.from(TestingStatus, (x) => x.value).join(","),
      //  TestingStatus: TestStatus,
      TPIRequired: TPIRequired,
      DepartmentIDEncrypted: DepartmentID,
      TestMasterIDEncrypted: TestID,
      CustomerRepresentativeIDEncrypt: CustomerRepresentativeIDEncrypt,
      FromDate: FromDate
        ? moment(FromDate).format("YYYY-MM-DD").replace(/^\-/, "")
        : "",
      ToDate: ToDate
        ? moment(ToDate).format("YYYY-MM-DD").replace(/^\-/, "")
        : "",
      EmployeeIDEncrypted: AuthUser?.ReferenceIDEncrypt,
    };
    await post(POST_GetTestingList, payload)
      .then((response) => {
        setRecordCount(response?.TotalRecordCount);
        //setTestingList(response?.List);
        formik.setFieldValue(
          "testingList",
          response?.List?.map((item) => ({
            ...item,
            showTest: false,
            //IsNDT: true,
          })),
        );
        formikFilter.setFieldValue("TestingPending", response?.TestingPending);
        formikFilter.setFieldValue(
          "TestingDraftSave",
          response?.TestingDraftSave,
        );
        formikFilter.setFieldValue(
          "TestingUnapproved",
          response?.TestingUnapproved,
        );
        formikFilter.setFieldValue(
          "TestingApproved",
          response?.TestingApproved,
        );
        formikFilter.setFieldValue(
          "TestingRejectRectify",
          response?.TestingRejectRectify,
        );
        formikFilter.setFieldValue("TotalTesting", response?.TotalTesting);
        setIsLoading(false);
        if (page > 1 && response?.List?.length === 0) {
          setCurrentPage(page - 1);
          getData(page - 1, sizePerPage);
        } else {
          setCurrentPage(page);
        }
        setCurrentSizePerPage(sizePerPage);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const getResetData = async () => {
    setIsLoading(true);

    // formikFilter.resetForm();
    formikFilter.setValues({
      TCNo: "",
      InwardNo: "",
      FromDate: new Date(currentDate.setMonth(currentDate.getMonth() - 1)),
      ToDate: new Date(),
      DepartmentID: "",
      TestingStatus:
        testStatusOptions?.filter(
          (x) => x.value == 1 || x.value == 2 || x.value == 3,
        ) ?? "",
      TestID: "",
      CustomerRepresentativeIDEncrypt: "",
      TPIRequired: -1,
      TestingPending: 0,
      TestingDraftSave: 0,
      TestingUnapproved: 0,
      TestingApproved: 0,
      TestingRejectRectify: 0,
      TotalTesting: 0,
    });

    setCurrentPage(1);
    setSortBy("");
    setOrderBy("asc");

    setIsReset(true);
  };

  const getCustomerRepresentativeDDL = () => {
    setIsLoading(true);
    post(POST_GetAllCustomerRepresentativeDropDown, {
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
      CustomerIDEncrypted: "",
    })
      .then((response) => {
        if (response?.IsSuccess) {
          setCustomerRepresentativeOptions(
            response?.ListOfCustomerRepresentative?.map((item) => ({
              label: item?.ProjectHandleByName,
              value: item?.ProjectHandleByEncrypted,
              IsDefault: item?.IsDefault,
            })),
          );
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  // useEffect(() => {
  //   getDepartmentDDL();
  //   getTestDDL();
  //   getStatusDDL();
  //   getData(1, currentSizePerPage);
  // }, [sortBy, orderBy]);

  useEffect(() => {
    if (DepartmentID) {
      getTestDDL(DepartmentID);
    } else {
      setTestOptions([]);
      formikFilter.setFieldValue("TestID", "");
    }
  }, [DepartmentID]);

  const getDepartmentDDL = async () => {
    setIsLoading(true);
    await post(POST_GetDepartmentDropDownList, {
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
    })
      .then((response) => {
        if (response?.IsSuccess) {
          setDepartmentOptions(
            response?.List?.map((item) => ({
              label: item.DepartmentName,
              value: item.DepartmentIDEncrypted,
            })),
          );
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const getTestDDL = async (departmentID) => {
    setIsLoading(true);
    await post(POST_DDLGetTestMasterByDepartmentID, {
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
      DepartmentIDEncrypted: departmentID,
    })
      .then((response) => {
        if (response?.IsSuccess) {
          setTestOptions(
            response?.List?.map((item) => ({
              label: item.TestName,
              value: item.TestMasterIDEncrypted,
            })),
          );
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const getStatusDDL = () => {
    if (
      AuthUser?.Permissions?.ApprovalWorkflow == 1 &&
      AuthUser?.Permissions?.TestingApprovalRequired == true
    ) {
      // setTestStatusOptions([
      //   { label: "Pending", value: 1 },
      //   { label: "Draft Save", value: 2 },
      //   { label: "Unapproved", value: 3 },
      //   { label: "Approved", value: 4 },
      //   { label: "Revise & Rectify", value: 5 },
      // ]);
    } else {
      setTestStatusOptions([
        { label: "Pending", value: 1 },
        { label: "Draft Save", value: 2 },
        { label: "Complete", value: 4 },
        { label: "Revise & Rectify", value: 5 },
      ]);
    }
  };

  useEffect(() => {
    if (testStatusOptions?.length == 4) {
      if (!filter?.TestingStatus) {
        formikFilter.setFieldValue(
          "TestingStatus",
          testStatusOptions?.filter((x) => x.value == 1 || x.value == 2) ?? "",
        );
      }
    }
  }, [testStatusOptions]);

  // const exportReport = () => {
  // };

  const fnCallback = () => {
    getData(currentPage, currentSizePerPage);
  };

  useEffect(() => {
    if (!showTestingApprovalModal) {
      setInwardMaterialID("");
    }
  }, [showTestingApprovalModal]);

  useEffect(() => {
    if (!showTestingNDTApprovalModal) {
      setInwardMaterialID("");
    }
  }, [showTestingNDTApprovalModal]);

  const [
    showSampleDepartmentReceivedMarkModal,
    setShowSampleDepartmentReceivedMarkModal,
  ] = useState(false);

  const validationSchemaSampleDepartmentReceivedMark = Yup.object().shape({
    ReceivedDepartmentIDEncrypted: Yup.string().required(
      "Department Name is required field",
    ),
  });

  const formikSampleDepartmentReceivedMark = useFormik({
    validationSchema: validationSchemaSampleDepartmentReceivedMark,
    onSubmit: (values, formikHelpers) =>
      handleValidSubmitSampleDepartmentReceivedMark(values, formikHelpers),
    initialValues: {
      InwardIDEncrypted: "",
      InwardMaterialIDEncrypted: "",
      InwardDate: "",
      ReceivedSampleTCNo: "",
      ReceivedSampleDetail: "",
      ReceivedDepartmentIDEncrypted: "",
      ReceivedByEmployeeIDEncrypted: AuthUser?.ReferenceIDEncrypt,
      ReceivedRemarks: "",
      ListOfSampleDepartmentTracking: [],
    },
    validateOnBlur: false,
  });

  const {
    values: { ListOfSampleDepartments, ListOfSampleDepartmentTracking },
  } = formikSampleDepartmentReceivedMark;

  const handleValidSubmitSampleDepartmentReceivedMark = (values) => {
    let payload = {
      InwardIDEncrypted: values?.InwardIDEncrypted,
      InwardMaterialIDEncrypted: values?.InwardMaterialIDEncrypted,
      BranchIDEncrypted: AuthUser?.BranchIDEncrypt,
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
      CreatedByEncrypted: AuthUser?.ReferenceIDEncrypt,
      DepartmentIDEncrypted: values?.ReceivedDepartmentIDEncrypted,
      ReceivedByEmployeeIDEncrypted: AuthUser?.ReferenceIDEncrypt,
      Remarks: values?.ReceivedRemarks,
    };

    post(POST_SampleDepartmentReceivedMarkingInsert, payload)
      .then((response) => {
        if (response?.IsSuccess) {
          successMessage(response?.Message);
          setIsLoading(false);
          setShowSampleDepartmentReceivedMarkModal(false);
          getData(currentPage, currentSizePerPage);
        } else {
          errorMessage(response?.Message);
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const openSampleDeparmentReceivedMarkDialog = async (
    InwardMaterialID,
    index,
  ) => {
    setIsLoading(true);
    await post(POST_GetSampleDepartmentReceivedMarkingDetail, {
      InwardMaterialIDEncrypted: InwardMaterialID,
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
      BranchIDEncrypted: AuthUser?.BranchIDEncrypt,
    })
      .then((response) => {
        if (response?.IsSuccess) {
          formikSampleDepartmentReceivedMark.resetForm();
          formikSampleDepartmentReceivedMark.setFieldValue(
            "InwardIDEncrypted",
            response?.InwardIDEncrypted,
          );
          formikSampleDepartmentReceivedMark.setFieldValue(
            "InwardMaterialIDEncrypted",
            InwardMaterialID,
          );
          formikSampleDepartmentReceivedMark.setFieldValue(
            "ReceivedSampleTCNo",
            response?.TCNo,
          );
          formikSampleDepartmentReceivedMark.setFieldValue(
            "InwardDate",
            response?.InwardDate,
          );
          formikSampleDepartmentReceivedMark.setFieldValue(
            "ReceivedSampleDetail",
            response?.SampleDetail,
          );
          formikSampleDepartmentReceivedMark.setFieldValue(
            "ListOfSampleDepartmentTracking",
            response?.ListOfDepartment,
          );
        }
        setIsLoading(false);
        setShowSampleDepartmentReceivedMarkModal(true);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  return (
    <>
      <div className="card m-1">
        <div className="card-body p-1">
          <Spin
            size="large"
            spinning={isLoading}
            tip={"Loading..."}
            style={{ position: "fixed" }}
          >
            <div className="table-responsive active-projects style-1 shorting">
              <div className="tbl-caption p-2">
                <h4 className="heading mb-0">Testing</h4>
                <div className="d-flex align-items-center">
                  <button
                    type="button"
                    // className="btn btn-primary btn-sm me-2"
                    className="btn btn-outline-primary btn-sm me-2"
                    onClick={(e) => {
                      getResetData();
                    }}
                  >
                    <i className="fa fa-window-restore" aria-hidden="true"></i>
                    {"  "}
                    Reset
                  </button>
                  <button
                    type="button"
                    // className="btn btn-primary btn-sm me-2"
                    className="btn btn-outline-primary btn-sm me-2"
                    onClick={(e) => {
                      getData();
                      // setShowFilter(false);
                    }}
                  >
                    <i className="fa-solid fa-refresh me-2"></i> Reload
                  </button>
                  <button
                    type="button"
                    // className="btn btn-primary btn-sm me-2"
                    className="btn btn-outline-primary btn-sm me-2"
                    onClick={() => setShowFilter(!showFilter)}
                  >
                    <i className="fa-solid fa-filter me-2"></i>Filter
                  </button>
                  {/* <Link
                    className="btn btn-primary light btn-sm me-2"
                    onClick={exportReport}
                  >
                    <i className="fa-solid fa-file-excel" /> Export Report
                  </Link> */}
                </div>
              </div>
              <hr className="mt-0 mb-1"></hr>
              <div className="p-2 pt-0 pb-0">
                {showFilter ? (
                  <div>
                    <FormikProvider value={formikFilter}>
                      <Form onSubmit={formikFilter.handleSubmit}>
                        <Row className="me-0">
                          <Col lg={2}>
                            <Field
                              label="TC No"
                              name="TCNo"
                              placeholder={"Search here..."}
                              component={CustomInput}
                            />
                          </Col>
                          <Col lg={2}>
                            <Field
                              label="Inward No"
                              name="InwardNo"
                              placeholder={"Search here..."}
                              component={CustomInput}
                            />
                          </Col>
                          <Col lg={3}>
                            <Field
                              label="Department"
                              name="DepartmentID"
                              placeholder={"Select Department"}
                              options={departmentOptions}
                              component={CustomSelect}
                              menuPosition="fixed"
                            />
                          </Col>
                          <Col lg={3}>
                            <Field
                              label="Test"
                              name="TestID"
                              placeholder={"Select Test"}
                              options={testOptions}
                              component={CustomSelect}
                              menuPosition="fixed"
                            />
                          </Col>
                        </Row>
                        <Row className="me-0">
                          <Col lg={2}>
                            <Field
                              label="Representative"
                              name="CustomerRepresentativeIDEncrypt"
                              placeholder={"Select Representative"}
                              options={customerRepresentativeOptions}
                              component={CustomSelect}
                              menuPosition="fixed"
                            />
                          </Col>
                          <Col lg={2}>
                            <Field
                              label="TPI Required"
                              name="TPIRequired"
                              placeholder={"Select TPI Required"}
                              options={tPIRequiredOptions}
                              component={CustomSelect}
                              isClearable={false}
                            />
                          </Col>
                          <Col lg={3}>
                            <Field
                              label="Test Status"
                              name="TestingStatus"
                              placeholder={"Select Test Status"}
                              options={testStatusOptions}
                              component={CustomMultiSelect}
                              isMulti={true}
                              menuPosition="fixed"
                            />
                          </Col>
                          <Col lg={3}>
                            <div className="d-flex">
                              <Field
                                label="From Date"
                                name="FromDate"
                                placeholder={"Select From Date"}
                                component={CustomFlatpickr}
                                options={{
                                  altInput: true,
                                  altFormat: "j-M-Y",
                                  dateFormat: "d-m-Y",
                                }}
                              />
                              <div>&nbsp;</div>
                              {/* </Col>
                          <Col lg={2}> */}
                              <Field
                                label="To Date"
                                name="ToDate"
                                placeholder={"Select To Date"}
                                component={CustomFlatpickr}
                                options={{
                                  altInput: true,
                                  altFormat: "j-M-Y",
                                  dateFormat: "d-m-Y",
                                  minDate: FromDate,
                                }}
                              />
                            </div>
                          </Col>
                          <Col lg={2}>
                            <label className="mb-1">&nbsp;</label>
                            <div className="d-flex">
                              <div className="d-lg-block">
                                <Link
                                  // className="btn btn-primary btn-sm mb-1"
                                  className="btn btn-primary btn-sm mb-1"
                                  onClick={(e) => {
                                    getData();
                                  }}
                                >
                                  <i
                                    className="fa fa-search"
                                    aria-hidden="true"
                                  ></i>{" "}
                                  Search
                                </Link>
                              </div>
                            </div>
                          </Col>
                        </Row>
                      </Form>
                    </FormikProvider>
                  </div>
                ) : (
                  ""
                )}

                <div className="bootstrap-badge pt-2">
                  <label
                    className="me-1 badge p-1 pb-2"
                    style={{
                      backgroundColor: "#ed7c79",
                      color: "#ffffff",
                      minWidth: "100px",
                    }}
                  >
                    Pending : {TestingPending}
                  </label>

                  <label
                    className="me-1 badge p-1 pb-2"
                    style={{
                      backgroundColor: "#80c9ff",
                      color: "#ffffff",
                      minWidth: "100px",
                    }}
                  >
                    Draft : {TestingDraftSave}
                  </label>

                  {AuthUser?.Permissions?.ApprovalWorkflow == 1 &&
                  AuthUser?.Permissions?.TestingApprovalRequired == true ? (
                    <>
                      {" "}
                      <label
                        className="me-1 badge p-1 pb-2"
                        style={{
                          backgroundColor: "#4aa493",
                          color: "#ffffff",
                          minWidth: "100px",
                        }}
                      >
                        Unapproved : {TestingUnapproved}
                      </label>
                      <label
                        className="me-1 badge p-1 pb-2"
                        style={{
                          backgroundColor: "#419841",
                          color: "#ffffff",
                          minWidth: "100px",
                        }}
                      >
                        Approved : {TestingApproved}
                      </label>
                    </>
                  ) : (
                    <label
                      className="me-1 badge p-1 pb-2"
                      style={{
                        backgroundColor: "#419841",
                        color: "#ffffff",
                        minWidth: "100px",
                      }}
                    >
                      Complete : {TestingApproved}
                    </label>
                  )}

                  <label
                    className="me-1 badge p-1 pb-2"
                    style={{
                      backgroundColor: "#f79f50",
                      color: "#ffffff",
                      minWidth: "100px",
                    }}
                  >
                    Revise & Rectify : {TestingRejectRectify}
                  </label>
                </div>
                <div
                  id="Testing-tbl_wrapper"
                  className="dataTables_wrapper no-footer mt-1"
                >
                  <table
                    id="Testing-tbl"
                    className="table dataTable no-footer mb-0"
                  >
                    <thead>
                      <tr>
                        {AuthUser?.Permissions?.ApprovalWorkflow == 1 &&
                        AuthUser?.Permissions?.TestingApprovalRequired ==
                          true ? (
                          <th width="4%"></th>
                        ) : (
                          <th width="2%"></th>
                        )}

                        <th
                          style={{
                            width: "15%",
                            cursor: "pointer",
                          }}
                          onClick={() => {
                            handleClickSorting("TCNo");
                          }}
                        >
                          TC No{" "}
                          <span className="ml-1">
                            {sortBy == "TCNo" ? (
                              orderBy == "desc" ? (
                                <i
                                  className="fa fa-arrow-down ms-2 fs-14"
                                  style={{ opacity: "0.7" }}
                                />
                              ) : (
                                <i
                                  className="fa fa-arrow-up ms-2 fs-14"
                                  style={{ opacity: "0.7" }}
                                />
                              )
                            ) : (
                              <i
                                className="fa fa-sort ms-2 fs-14"
                                style={{ opacity: "0.3" }}
                              />
                            )}
                          </span>
                        </th>
                        <th
                          style={{
                            width: "15%",
                            cursor: "pointer",
                          }}
                          onClick={() => {
                            handleClickSorting("InwardDate");
                          }}
                        >
                          Inward No | Date{" "}
                          <span className="ml-1">
                            {sortBy == "InwardDate" ? (
                              orderBy == "desc" ? (
                                <i
                                  className="fa fa-arrow-down ms-2 fs-14"
                                  style={{ opacity: "0.7" }}
                                />
                              ) : (
                                <i
                                  className="fa fa-arrow-up ms-2 fs-14"
                                  style={{ opacity: "0.7" }}
                                />
                              )
                            ) : (
                              <i
                                className="fa fa-sort ms-2 fs-14"
                                style={{ opacity: "0.3" }}
                              />
                            )}
                          </span>
                        </th>
                        <th
                          style={{
                            width: "35%",
                            cursor: "pointer",
                          }}
                          onClick={() => {
                            handleClickSorting("SampleDetail");
                          }}
                        >
                          Sample Detail{" "}
                          <span className="ml-1">
                            {sortBy == "SampleDetail" ? (
                              orderBy == "desc" ? (
                                <i
                                  className="fa fa-arrow-down ms-2 fs-14"
                                  style={{ opacity: "0.7" }}
                                />
                              ) : (
                                <i
                                  className="fa fa-arrow-up ms-2 fs-14"
                                  style={{ opacity: "0.7" }}
                                />
                              )
                            ) : (
                              <i
                                className="fa fa-sort ms-2 fs-14"
                                style={{ opacity: "0.3" }}
                              />
                            )}
                          </span>
                        </th>
                        <th
                          style={{
                            width: "13%",
                            cursor: "pointer",
                          }}
                          onClick={() => {
                            handleClickSorting("CustomerRepresentativeName");
                          }}
                        >
                          Representative{" "}
                          <span className="ml-1">
                            {sortBy == "CustomerRepresentativeName" ? (
                              orderBy == "desc" ? (
                                <i
                                  className="fa fa-arrow-down ms-2 fs-14"
                                  style={{ opacity: "0.7" }}
                                />
                              ) : (
                                <i
                                  className="fa fa-arrow-up ms-2 fs-14"
                                  style={{ opacity: "0.7" }}
                                />
                              )
                            ) : (
                              <i
                                className="fa fa-sort ms-2 fs-14"
                                style={{ opacity: "0.3" }}
                              />
                            )}
                          </span>
                        </th>
                        <th
                          style={{
                            width: "10%",
                            cursor: "pointer",
                          }}
                          onClick={() => {
                            handleClickSorting("TPIRequired");
                          }}
                        >
                          TPI Required{" "}
                          <span className="ml-1">
                            {sortBy == "TPIRequired" ? (
                              orderBy == "desc" ? (
                                <i
                                  className="fa fa-arrow-down ms-2 fs-14"
                                  style={{ opacity: "0.7" }}
                                />
                              ) : (
                                <i
                                  className="fa fa-arrow-up ms-2 fs-14"
                                  style={{ opacity: "0.7" }}
                                />
                              )
                            ) : (
                              <i
                                className="fa fa-sort ms-2 fs-14"
                                style={{ opacity: "0.3" }}
                              />
                            )}
                          </span>
                        </th>
                        <th
                          style={{
                            width: "12%",
                            cursor: "pointer",
                            textAlign: "left",
                          }}
                          onClick={() => {
                            handleClickSorting("EDD");
                          }}
                        >
                          EDD{" "}
                          <span className="ml-1">
                            {sortBy == "EDD" ? (
                              orderBy == "desc" ? (
                                <i
                                  className="fa fa-arrow-down ms-2 fs-14"
                                  style={{ opacity: "0.7" }}
                                />
                              ) : (
                                <i
                                  className="fa fa-arrow-up ms-2 fs-14"
                                  style={{ opacity: "0.7" }}
                                />
                              )
                            ) : (
                              <i
                                className="fa fa-sort ms-2 fs-14"
                                style={{ opacity: "0.3" }}
                              />
                            )}
                          </span>
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {testingList?.length > 0 ? (
                        testingList?.map((item, indx) => (
                          <React.Fragment key={indx}>
                            <tr
                              key={indx}
                              style={{ cursor: "pointer" }}
                              onClick={() => {
                                formik.setFieldValue(
                                  `testingList[${indx}].showTest`,
                                  !item.showTest,
                                );
                              }}
                            >
                              <td
                                style={{
                                  verticalAlign: "top",
                                }}
                                rowSpan={
                                  item.TestList?.length > 0
                                    ? item.showTest == true
                                      ? 2
                                      : 1
                                    : 1
                                }
                              >
                                {/* <Link
                                  to="#"
                                  className="icon-box icon-box-md me-1"
                                  title="Sample Received Mark"
                                  onClick={(e) => {
                                    if (item?.IsHold == false) {
                                      openSampleDeparmentReceivedMarkDialog(
                                        item?.InwardMaterialIDEncrypted,
                                        indx,
                                      );
                                    }
                                  }}
                                  disabled={item?.IsHold}
                                >
                                  {SVGICON.CalendarList}
                                </Link> */}

                                {AuthUser?.UserType !== 1 ||
                                formsList?.filter(
                                  (x) =>
                                    x?.FormID == 33 && (x?.IsAdd || x?.IsEdit),
                                )?.length > 0 ? (
                                  item?.IsNDT ? (
                                    <Link
                                      to={
                                        item?.IsHold == true
                                          ? "#"
                                          : `/testing-ndt/${window.btoa(
                                              item.InwardMaterialIDEncrypted,
                                            )}`
                                      }
                                      // className="icon-box icon-box-md bg-primary-light me-1"
                                      className="icon-box icon-box-md me-1"
                                      title="Edit"
                                      disabled={item?.IsHold}
                                    >
                                      {SVGICON.EditPrimary}
                                    </Link>
                                  ) : (
                                    <Link
                                      to={
                                        item?.IsHold == true
                                          ? "#"
                                          : `/testing/${window.btoa(
                                              item.InwardMaterialIDEncrypted,
                                            )}`
                                      }
                                      // className="icon-box icon-box-md bg-primary-light me-1"
                                      className="icon-box icon-box-md me-1"
                                      title="Edit"
                                      disabled={item?.IsHold}
                                    >
                                      {SVGICON.EditPrimary}
                                    </Link>
                                  )
                                ) : (
                                  ""
                                )}

                                {item?.TotalTestTestingDone > 0 &&
                                  (AuthUser?.UserType !== 1 ||
                                    AuthUser?.Permissions
                                      ?.IsOperationApprover == true) &&
                                  AuthUser?.Permissions?.ApprovalWorkflow ==
                                    1 &&
                                  AuthUser?.Permissions
                                    ?.TestingApprovalRequired == true && (
                                    <Link
                                      to="#"
                                      // className="icon-box icon-box-md bg-primary-light"
                                      className="icon-box icon-box-md me-1"
                                      title="Approve"
                                      onClick={() => {
                                        if (item?.IsHold == false) {
                                          setInwardMaterialID(
                                            item?.InwardMaterialIDEncrypted,
                                          );
                                          if (item?.IsNDT === true) {
                                            setIsNDT(true);
                                            setShowTestingNDTApprovalModal(
                                              true,
                                            );
                                            setShowTestingApprovalModal(false);
                                          } else {
                                            setIsNDT(false);
                                            setShowTestingApprovalModal(true);
                                            setShowTestingNDTApprovalModal(
                                              false,
                                            );
                                          }
                                        }
                                      }}
                                      disabled={item?.IsHold}
                                    >
                                      {item.TotalTestTesting ==
                                      item.TotalTestTestingApproved
                                        ? SVGICON.Verified
                                        : SVGICON.Unverified}
                                    </Link>
                                  )}

                                {item?.TotalTestTestingDone > 0 &&
                                (AuthUser?.UserType !== 1 ||
                                  formsList?.filter(
                                    (x) => x?.FormID == 33 && x?.IsDelete,
                                  )?.length > 0) ? (
                                  <Link
                                    to="#"
                                    // className="icon-box icon-box-md bg-danger-light me-1"
                                    className="icon-box icon-box-md me-1"
                                    title="Delete"
                                    onClick={() => {
                                      if (item?.IsHold == false) {
                                        delete_Record(
                                          POST_TestingsDelete,
                                          {
                                            InwardMaterialIDEncrypted:
                                              item?.InwardMaterialIDEncrypted,
                                            ModifiedByEncrypted:
                                              AuthUser?.ReferenceIDEncrypt
                                                ? AuthUser?.ReferenceIDEncrypt
                                                : "0",
                                          },
                                          setIsLoading,
                                          fnCallback,
                                          item.TCNo +
                                            " - all the test Testing should be deleted.",
                                        );
                                      }
                                    }}
                                    disabled={item?.IsHold}
                                  >
                                    {SVGICON.DeleteDanger}
                                  </Link>
                                ) : (
                                  ""
                                )}
                              </td>
                              <td>
                                {item.TCNo}{" "}
                                {item?.IsHold == true && (
                                  <>
                                    <b>[Hold]</b>
                                    <OverlayTrigger
                                      trigger={["hover", "focus"]}
                                      key={indx}
                                      responsive={true}
                                      overlay={
                                        <Tooltip className="toltip-popover">
                                          <strong className="p-1">
                                            <label>Hold:</label>{" "}
                                            {item?.HoldReason}
                                          </strong>
                                        </Tooltip>
                                      }
                                    >
                                      <span>
                                        <i
                                          className="fa fa-info-circle ms-2"
                                          style={{
                                            cursor: "pointer",
                                            color: "#9698ab",
                                          }}
                                        ></i>
                                      </span>
                                    </OverlayTrigger>
                                  </>
                                )}
                              </td>
                              <td>{item.InwardNo}</td>
                              {/* <td style={{ whiteSpace: "normal" }}>
                                {item.SampleDetail}
                              </td> */}
                              <td
                                style={{ textAlign: "left", cursor: "pointer" }}
                                className="popupOverlay"
                              >
                                <OverlayTrigger
                                  trigger={["hover", "focus"]}
                                  key={indx}
                                  responsive={true}
                                  overlay={
                                    <Tooltip className="toltip-popover">
                                      <strong className="p-1">
                                        {item.SampleDetail}
                                      </strong>
                                    </Tooltip>
                                  }
                                >
                                  <span>{item.SampleDetail}</span>
                                </OverlayTrigger>
                              </td>
                              <td>{item.CustomerRepresentativeName}</td>
                              <td>
                                {item.IsTPIRequired == true ? "Yes" : "No"}
                              </td>

                              <td style={{ textAlign: "left" }}>{item.EDD}</td>
                            </tr>
                            {item.TestList?.length > 0 ? (
                              <tr
                                style={{
                                  display: item.showTest == true ? "" : "none",
                                }}
                              >
                                <td
                                  colSpan={6}
                                  style={{
                                    textAlign: "left",
                                    whiteSpace: "initial",
                                  }}
                                  className="p-2"
                                >
                                  {item.TestList?.map((itemtest, indxtest) => (
                                    <React.Fragment key={indxtest}>
                                      {item?.IsNDT ? (
                                        <Link
                                          // className="badge mb-2 me-2"
                                          className="btn-sm me-2"
                                          title={
                                            itemtest?.RetestRemarks
                                              ? "ReTest - " +
                                                itemtest?.RetestRemarks
                                              : ""
                                          }
                                          to={
                                            (AuthUser?.UserType !== 1 ||
                                              formsList?.filter(
                                                (x) =>
                                                  x?.FormID == 33 &&
                                                  (x?.IsAdd || x?.IsEdit),
                                              )?.length > 0) &&
                                            itemtest?.AllowTesting == true &&
                                            item?.IsHold == false
                                              ? `/testing-ndt/${window.btoa(
                                                  item.InwardMaterialIDEncrypted,
                                                )}/${window.btoa(
                                                  itemtest.InwardMaterialTestDetailIDEncrypted,
                                                )}`
                                              : "#"
                                          }
                                          style={{
                                            backgroundColor:
                                              itemtest?.TestingStatus == 1
                                                ? "#ed7c79"
                                                : itemtest?.TestingStatus == 2
                                                  ? "#80c9ff"
                                                  : itemtest?.TestingStatus == 3
                                                    ? "#4aa493"
                                                    : itemtest?.TestingStatus ==
                                                        4
                                                      ? "#419841"
                                                      : itemtest?.TestingStatus ==
                                                          5
                                                        ? "#f79f50"
                                                        : "",
                                            color: "#fff",
                                            cursor:
                                              (AuthUser?.UserType !== 1 ||
                                                formsList?.filter(
                                                  (x) =>
                                                    x?.FormID == 33 &&
                                                    (x?.IsAdd || x?.IsEdit),
                                                )?.length > 0) &&
                                              itemtest?.AllowTesting == true &&
                                              item?.IsHold == false
                                                ? "pointer"
                                                : "not-allowed",
                                          }}
                                          disabled={item?.IsHold}
                                        >
                                          {itemtest.TestName}
                                        </Link>
                                      ) : (
                                        <Link
                                          // className="badge mb-2 me-2"
                                          className="btn-sm me-2"
                                          title={
                                            itemtest?.RetestRemarks
                                              ? "ReTest - " +
                                                itemtest?.RetestRemarks
                                              : ""
                                          }
                                          to={
                                            (AuthUser?.UserType !== 1 ||
                                              formsList?.filter(
                                                (x) =>
                                                  x?.FormID == 33 &&
                                                  (x?.IsAdd || x?.IsEdit),
                                              )?.length > 0) &&
                                            itemtest?.AllowTesting == true &&
                                            item?.IsHold == false
                                              ? `/testing/${window.btoa(
                                                  item.InwardMaterialIDEncrypted,
                                                )}/${window.btoa(
                                                  itemtest.InwardMaterialTestDetailIDEncrypted,
                                                )}`
                                              : "#"
                                          }
                                          style={{
                                            backgroundColor:
                                              itemtest?.TestingStatus == 1
                                                ? "#ed7c79"
                                                : itemtest?.TestingStatus == 2
                                                  ? "#80c9ff"
                                                  : itemtest?.TestingStatus == 3
                                                    ? "#4aa493"
                                                    : itemtest?.TestingStatus ==
                                                        4
                                                      ? "#419841"
                                                      : itemtest?.TestingStatus ==
                                                          5
                                                        ? "#f79f50"
                                                        : "",
                                            color: "#fff",
                                            cursor:
                                              (AuthUser?.UserType !== 1 ||
                                                formsList?.filter(
                                                  (x) =>
                                                    x?.FormID == 33 &&
                                                    (x?.IsAdd || x?.IsEdit),
                                                )?.length > 0) &&
                                              itemtest?.AllowTesting == true &&
                                              item?.IsHold == false
                                                ? "pointer"
                                                : "not-allowed",
                                          }}
                                          disabled={item?.IsHold}
                                        >
                                          {itemtest.TestName}
                                        </Link>
                                      )}
                                    </React.Fragment>
                                  ))}
                                </td>
                              </tr>
                            ) : (
                              ""
                            )}
                          </React.Fragment>
                        ))
                      ) : (
                        <tr>
                          <td colSpan={8} style={{ textAlign: "left" }}>
                            <div>{"No Record Found..."}</div>
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>

                  <hr className="mt-0 mb-1"></hr>
                  <div className="d-sm-flex text-center justify-content-between align-items-center">
                    <CustomSizePerPage
                      getData={getData}
                      currentSizePerPage={currentSizePerPage}
                    />
                    <div className="dataTables_info">
                      Showing{" "}
                      {recordCount > 0
                        ? (currentPage - 1) * currentSizePerPage + 1
                        : 0}{" "}
                      to{" "}
                      {recordCount > currentPage * currentSizePerPage
                        ? currentPage * currentSizePerPage
                        : recordCount}{" "}
                      of {recordCount} entries
                    </div>
                    <CustomPaginationButtons
                      totalPages={recordCount / currentSizePerPage}
                      currentPage={currentPage}
                      currentSizePerPage={currentSizePerPage}
                      getData={getData}
                    />
                  </div>
                </div>
              </div>
            </div>
          </Spin>
          {setshowIsNDT ? (
            <TestingNDTApproval
              showTestingNDTApprovalModal={showTestingNDTApprovalModal}
              setShowTestingNDTApprovalModal={setShowTestingNDTApprovalModal}
              InwardMaterialID={inwardMaterialID}
              fnCallback={fnCallback}
            />
          ) : (
            <TestingApproval
              showTestingApprovalModal={showTestingApprovalModal}
              setShowTestingApprovalModal={setShowTestingApprovalModal}
              InwardMaterialID={inwardMaterialID}
              fnCallback={fnCallback}
            />
          )}
          <Modal
            className="fade"
            show={showSampleDepartmentReceivedMarkModal}
            onHide={setShowSampleDepartmentReceivedMarkModal}
            size="xl"
            backdrop="static"
          >
            <Spin
              size="large"
              spinning={isLoading}
              tip={"Loading..."}
              style={{ position: "fixed" }}
            >
              <FormikProvider value={formikSampleDepartmentReceivedMark}>
                <Form
                  onSubmit={formikSampleDepartmentReceivedMark.handleSubmit}
                >
                  <Modal.Header>
                    <Modal.Title>
                      Sample Department Received Marking
                    </Modal.Title>
                    <Button
                      type="button"
                      variant=""
                      className="btn-close"
                      onClick={() =>
                        setShowSampleDepartmentReceivedMarkModal(false)
                      }
                    ></Button>
                  </Modal.Header>
                  <Modal.Body>
                    <Row>
                      <Col lg={6}>
                        <label>TC No:</label>{" "}
                        {
                          formikSampleDepartmentReceivedMark.values
                            .ReceivedSampleTCNo
                        }
                      </Col>
                      <Col lg={6}>
                        <label>Inward Date:</label>{" "}
                        {formikSampleDepartmentReceivedMark.values.InwardDate}
                      </Col>
                      <Col lg={12}>
                        <label>Sample Detail:</label>{" "}
                        {
                          formikSampleDepartmentReceivedMark.values
                            .ReceivedSampleDetail
                        }
                      </Col>
                      <hr className="mt-1 mb-1"></hr>
                      <Col lg={12} className="mb-2">
                        <label>Sample Tracking Information</label>
                        <div className="table-responsive active-projects style-1 shorting mb-2">
                          <div
                            id="MaterialTracking-tbl_wrapper"
                            className="dataTables_wrapper no-footer"
                          >
                            <table
                              id="MaterialTracking-tbl"
                              className="table dataTable no-footer mb-0"
                            >
                              <thead>
                                <tr>
                                  <th width="25%">Department Name</th>
                                  <th width="20%">Received At</th>
                                  <th width="25%" style={{ textAlign: "left" }}>
                                    Received By
                                  </th>
                                  <th width="30%" style={{ textAlign: "left" }}>
                                    Remarks
                                  </th>
                                </tr>
                              </thead>
                              <tbody>
                                {ListOfSampleDepartmentTracking?.length > 0 ? (
                                  ListOfSampleDepartmentTracking?.map(
                                    (item, indx) => (
                                      <tr key={indx}>
                                        <td>{item?.DepartmentName}</td>
                                        <td>{item?.ReceivedDateTime}</td>
                                        <td style={{ textAlign: "left" }}>
                                          {item?.EmployeeName}
                                        </td>
                                        <td
                                          style={{
                                            textAlign: "left",
                                            whiteSpace: "normal",
                                          }}
                                        >
                                          {item?.Remarks}
                                        </td>
                                      </tr>
                                    ),
                                  )
                                ) : (
                                  <tr>
                                    <td
                                      colSpan={4}
                                      style={{ textAlign: "left" }}
                                    >
                                      <div>{"No Record Found..."}</div>
                                    </td>
                                  </tr>
                                )}
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </Col>
                      <Col lg={4}>
                        <Field
                          label="Department Name"
                          name={"ReceivedDepartmentIDEncrypted"}
                          placeholder={"Select Department"}
                          options={departmentOptions}
                          component={CustomSelect}
                          required
                          menuPosition="fixed"
                        />
                      </Col>
                      <Col lg={4}>
                        <Field
                          label="Received At"
                          name={"ReceivedAt"}
                          placeholder={"Received At"}
                          component={CustomInput}
                          value={moment(new Date())
                            .format("DD-MMM-YYYY hh:mm a")
                            .replace(/^\-/, "")}
                          disabled={true}
                        />
                      </Col>
                      <Col lg={4}>
                        <Field
                          label="Received By Employee Name"
                          name={"ReceivedByEmployeeName"}
                          placeholder={"Received By Employee Name"}
                          component={CustomInput}
                          value={AuthUser?.Name}
                          disabled={true}
                        />
                      </Col>
                      <Col lg={8}>
                        <Field
                          label="Remarks"
                          name={"ReceivedRemarks"}
                          placeholder={"Remarks"}
                          component={CustomTextArea}
                          rows={3}
                        />
                      </Col>
                    </Row>
                  </Modal.Body>
                  <Modal.Footer>
                    <Button variant="primary btn-sm" type="submit">
                      <i className="fa-solid fa-floppy-disk"></i> Submit
                    </Button>
                    <Button
                      variant="danger btn-sm"
                      onClick={() =>
                        setShowSampleDepartmentReceivedMarkModal(false)
                      }
                    >
                      <i className="fa fa-cancel"></i> Cancel
                    </Button>
                  </Modal.Footer>
                </Form>
              </FormikProvider>
            </Spin>
          </Modal>
        </div>
      </div>
    </>
  );
};

export default Testing;
